<template>
  <div class="home-page cg-page">
    <div class="login-content">
      <div class="pt20 disflex" style="justify-content: space-between;position: fixed;background: linear-gradient(to bottom, #41d6fb,#41d6fb, #ffffff00);">
        <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
      </div>
      <div class="landing-page">
        <div class="">
          <div class="home-prize" style="padding-top: 100px;">
            <div class="home1">
              <img :src="isEN=='bur'?'../../static/images/login-bg3-bur.png':'../../static/images/login-bg3-bur.png'">
            </div>
          </div>
<!--          <div class="span fs33 ac mt30" style="width:50%;margin: 0 auto;">-->
<!--            {{$t('ladingpageTips')}}-->
<!--          </div>-->

          <div class="span fs33 ac mt30 app-en" style="width:50%;margin: 0 auto;">
            {{ msg }}
          </div>

          <div class="ac mt50">

            <button class="btn btn-blue btn-green0 mt50" style="min-width: 350px;"><span @click="goLogin">{{$t('subscribeNow')}}</span></button>
          </div>
          <div class="line"></div>
          <div class="mt20 ac" style="font-size:30px;padding:20px;color:#f00;font-weight:700;width: 80%;margin: 0 auto 40px;">
            {{$t('landingFont')}}
          </div>
          <div class="otp-b mt20" style="padding:0 20px;color:#000;font-size:22px;" v-html="$t('landingContent')"></div>

        </div>
      </div>
    </div>
    <Dialog ref="otpDialog" type="alert" :callback="getOtpSubmit" title="" width="100" :btnText="$t('OK')" :cancelText="$t('OK')" :modalFoot="false">
      <div class="login-content bgfff" slot="mdBox">
        <div class="answer-modal" style="background: #41d6fb;">
          <div style="width:90%;margin:0 auto">
            <div class="">
              <div class="answer-t1" style="border: none;" v-html="$t('optTips')">
              </div>
              <button class="btn btn-blue1 mt20" @click="getOtpSubmit">{{$t('OK')}}</button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'
export default {
  components:{
    Header,Dialog
  },
  data() {
    return {
      list:[],
      account:'',
      password:'',
      isShow:false,
      type:'daily',
      isEN:'bur',
      mobile:'',
      msg:'',
    }
  },
  created(){
    let msg = this.$route.query.msg
    if(msg){
      this.msg = msg
    }
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
  },
  methods: {
    back(){
      this.$router.go(-1);
    },
    clickDrown(){
      this.isShow = !this.isShow
    },
    getType(type){
      this.type = type
      this.isShow = false
    },
    getOtpSubmit(){
      this.$router.push({path:'/otp',query:{mobile:this.mobile}});
    },
    goLogin(){
      let that = this
      that.$api.post('/api/user/get_cg_url',null,r =>{

        window.location.href = r.data;

      })
    },
  }
}
</script>
<style scoped>
.drop-down-content{z-index:9;background:none;}
.landing-page{padding-bottom:60px;}
</style>



// WEBPACK FOOTER //
// src/page/errors.vue